<template>
  <Button
    icon="eenvandaag-general:share-outline"
    label="Delen"
    variant="secondary"
    :analytics="analytics"
    @click="handleClick"
    @click.middle="handleClick"
  />
</template>

<script setup lang="ts">
import useWebShare from '~/composables/useWebShare';
import type { IAnalytics } from '~~/types/local_types';

const shareText = 'Graag deel ik dit interessante artikel van Eenvandaag';
const { shareViaWebShare } = useWebShare();

const props = defineProps({
  articleTitle: {
    type: String,
    default: null,
  },
  analytics: {
    type: Object as () => IAnalytics,
    default: null,
  },
});

const handleClick = () => {
  shareViaWebShare(props.articleTitle, shareText);
};
</script>

<style lang="postcss" scoped></style>
